<div class="selection-banner d-flex align-items-center justify-content-between rounded-pill"
     *ngIf="isPageSelection || isAllSelection || (showManualSelection && isManualSelection)">

    <div *ngIf="isPageSelection">
        <span class="fw-semibold">{{ selectionInfo.pageItems }} {{ entityName }}</span> on this page are selected.
        <button class="btn btn-link text-decoration-none align-baseline"
                (click)="selectAll.emit()"
                data-identifier="table-selection-banner-select-all">
            Select {{ selectionInfo.totalItems }} {{ entityName }} in Current Filter
        </button>
    </div>

    <div *ngIf="showManualSelection && isManualSelection">
        <span class="fw-semibold">{{ selectionInfo.selectedItems }} {{ entityName }}</span> selected.
        <button class="btn btn-link text-decoration-none align-baseline"
                (click)="selectAll.emit()"
                data-identifier="table-selection-banner-select-all">
            Select {{ selectionInfo.totalItems }} {{ entityName }} in Current Filter
        </button>
    </div>

    <div *ngIf="isAllSelection">
        <span class="fw-semibold">{{ selectionInfo.totalItems }} {{ entityName }}</span> in Current Filter are selected.
        <button class="btn btn-link text-decoration-none align-baseline"
                (click)="clearSelection.emit()"
                data-identifier="table-selection-banner-clear-selection">
            Clear Selection
        </button>
    </div>

    <div class="d-flex">
        <button *ngIf="showSendVerificationEmail" class="btn btn-outline-primary me-2 rounded-pill"
                (click)="sendVerificationEmail.emit()"
                data-identifier="table-selection-banner-send-verification-email"> <i class="fa fa-envelope me-2"></i>Send Verification Email
        </button>
        <lib-tooltip [tooltipText]="downloadCsvTooltip">
            <button *ngIf="showDownloadCsv" class="btn btn-outline-primary me-2 rounded-pill"
                    [disabled]="disableDownloadCsv"
                    (click)="downloadCsv.emit()"
                    data-identifier="table-selection-banner-download-csv"> <i class="fa fa-download me-2"></i>Download (CSV)
            </button>
        </lib-tooltip>
        <button *ngIf="showPreconfigure" class="btn btn-outline-primary me-2 rounded-pill"
                (click)="preconfigure.emit()"
                data-identifier="table-selection-banner-preconfigure">
            Preconfigure
        </button>
    </div>
</div>
